export default __webpack_public_path__ + "static/media/circles.27a05431.png";